<script>
export default {
  name: 'ChatTour',
  data() {
    return {
      chatTourSteps: [
        {
          target: window.innerWidth > 1199 ? '.vs-sidebar-item-active' : '.navbar-custom',
          header: {
            title: `<strong>This is the Chat Tab</strong>`,
          },
          content: `Here you can send direct messages to the Guides who have an active application for one of your Job Posts.<br><br>You can exchange external contact details here if you wish to chat outside of Recruit a Guide.`,
          params: {
            enableScrolling: false,
            placement: 'auto',
          },
        },
        {
          target: '#active-chats',

          content: `Active Chats is a list of applicants you are currently chatting to.`,
          params: {
            enableScrolling: false,
            placement: 'auto-end',
          },
        },
        {
          target: '#applicant-chats',

          content: `This is the list of applicants who have applied to one of your jobs. You can initiate a chat by selecting one of these guides.`,
          params: {
            enableScrolling: false,
            placement: 'auto-end',
          },
        },
      ],
      tourCallbacks: {
        onSkip: this.markTourAsSeen,
        onFinish: this.markTourAsSeen,
      },
    };
  },
  mounted() {
    const employer = this.$store.getters['employerModule/getUser'];
    if (!employer.dashboardTours || !employer.dashboardTours.chatTourSeen) {
      setTimeout(() => {
        try {
          this.$tours['chatTour'].start();
        } catch (error) {
          return;
        }
      }, 1000);
    }
  },
  methods: {
    markTourAsSeen() {
      this.$store.dispatch('employerModule/patch', { dashboardTours: { chatTourSeen: true } });
    },
  },
};
</script>
<template>
  <v-tour name="chatTour" :steps="chatTourSteps" :callbacks="tourCallbacks"></v-tour>
</template>

<style lang="scss">
.v-step,
.v-step__header,
.v-step__arrow,
.v-step__arrow::before {
  background: #adca63 !important;
}
.v-step {
  border-radius: 10px !important;
  z-index: 99999 !important;
}
.v-step__header {
  border-top-right-radius: 10px !important;
  border-top-left-radius: 10px !important;
  margin-top: 0 !important;
}

.v-step__button {
  border-radius: 5px !important;
  border-top-width: 0.1rem !important;
  font-size: 1rem !important;
}
</style>
